var map = {
	"./critical-strike.mp4": 626,
	"./critical-strike.webm": 627,
	"./dirty-fightin.mp4": 628,
	"./dirty-fightin.webm": 629,
	"./eldar-preview.mp4": 630,
	"./eldar-preview.webm": 631,
	"./god-splitter.mp4": 632,
	"./god-splitter.webm": 633,
	"./grapplin-klaw.mp4": 634,
	"./grapplin-klaw.webm": 635,
	"./key-art-1080.mp4": 636,
	"./key-art-1080.webm": 637,
	"./key-art.mp4": 638,
	"./orks-preview.mp4": 639,
	"./orks-preview.webm": 640,
	"./psyker-blast.mp4": 641,
	"./psyker-blast.webm": 642,
	"./retribution.mp4": 643,
	"./retribution.webm": 644,
	"./singing-spear.mp4": 645,
	"./singing-spear.webm": 646,
	"./spacemarines-preview.mp4": 647,
	"./spacemarines-preview.webm": 648,
	"./spinnin-klaw.mp4": 649,
	"./spinnin-klaw.webm": 650,
	"./teaser-1080.mp4": 651,
	"./teaser-1080.webm": 652,
	"./temporal-weave.mp4": 653,
	"./temporal-weave.webm": 654,
	"./trailer-preview-460.mp4": 655,
	"./trailer-teaser-1080.mp4": 656,
	"./trailer-teaser-460.mp4": 657
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;



//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video ^\.\/.*$
// module id = 78
// module chunks = 0